import { put, takeEvery } from "@redux-saga/core/effects";
import { handleNotificationAlertCatch } from "common/method/handleNotificationAlert";
import AxiosCustom from "../../../common/components/apiConfig";

export const actionTypes = {
  selectDetailsTable: "[selectDetailsTable] Action",
  selectDetailsTableLoad: "[selectDetailsTableLoad] Action",
  selectDetailsTableAsync: "[selectDetailsTableAsync] Action",
};

const initialState = {
  data: [],
  loading: false,
};

export const select_details_table_reducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectDetailsTable:
      return {
        ...state,
        data: payload?.data?.results ? payload?.data?.results : [],
      };

    case actionTypes.selectDetailsTableLoad:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({ type: actionTypes.selectDetailsTableLoad, payload: payload });
  let config = {
    url: "select_request",
  };

  let data = {
    table: "transactions",
    method_type: "select_transactions",
    data: payload?.data ? payload?.data : {},
    sort_by: {},
    // size: "50",
    // from: "0",
  };

  try {
    let res = yield AxiosCustom(config, data);

    yield put({
      type: actionTypes.selectDetailsTable,
      payload: res.data.response,
    });
  } catch {
    handleNotificationAlertCatch();
    // yield put({ type: actionTypes.creaditSelectLoad, payload: false });
  } finally {
    yield put({ type: actionTypes.selectDetailsTableLoad, payload: false });
  }
}

export function* selectTableDetails() {
  yield takeEvery(actionTypes.selectDetailsTableAsync, handleWorker);
}
